import {
  AdjustmentChannel,
  NodeKind,
  TransformKind,
  assertAdjustmentsParams,
  isIdentityAdjustments,
  type AdjustmentsParams,
  type TransformStack,
} from '@/core/document'
import { useEditSession } from '@/core/store/editSession'
import { EditAction } from '@/core/history'
import { selectSelectedNode } from '@/core/store/selectors'
import { selectSelectedAdjustments } from '@/tools/adjustments/selectors'

function writeSelectedAdjustments(params: AdjustmentsParams): void {
  assertAdjustmentsParams(params)
  const state = useEditSession.getState()
  const selected = selectSelectedNode(state)
  state.updateNode(selected.id, (node) => {
    if (node.kind !== NodeKind.Image) {
      throw new Error(`Adjustment update requires an image node, received "${node.kind}"`)
    }
    const transforms: TransformStack = { ...node.transforms }
    if (isIdentityAdjustments(params)) delete transforms[TransformKind.Adjustments]
    else transforms[TransformKind.Adjustments] = { ...params }
    return { ...node, transforms }
  })
}

export function setSelectedAdjustment(channel: AdjustmentChannel, value: number): void {
  if (!Object.values(AdjustmentChannel).includes(channel)) {
    throw new Error(`Unknown adjustment channel: "${String(channel)}"`)
  }
  const state = useEditSession.getState()
  const current = selectSelectedAdjustments(state)
  writeSelectedAdjustments({ ...current, [channel]: value })
}

export function commitSelectedAdjustments(): void {
  useEditSession.getState().commitHistory(EditAction.AdjustPhoto)
}

export function resetSelectedAdjustments(): void {
  writeSelectedAdjustments({ brightness: 0, contrast: 0, saturation: 0 })
  useEditSession.getState().commitHistory(EditAction.AdjustPhoto)
}
